import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'

export const OfferProtectedRoute = ({ children, ...rest }) => {
  const { subscriptionStartTime } = useContext(BuyingInsuranceContextStore)
  let isOfferExpired = true
  if (subscriptionStartTime) {
    isOfferExpired = new Date(subscriptionStartTime).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
  }
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !isOfferExpired ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/insurance/summary',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}
